<zen-main-container>
  <sidebar-container>
    <div class="flex flex-col justify-center h-28 px-8">
      <h5 class="text-zen uppercase text-sm font-medium">{{ "txtOverallBalance" | translate:language:ModuleNames.Common }}</h5>
    </div>
    <div class="flex flex-col gap-6" *ngIf="balances?.entities.length">
      <ng-container *ngFor="let product of productCatalog">
        <ng-template *ngTemplateOutlet="unitOverview; context:{$implicit:product}"></ng-template>
      </ng-container>
    </div>

  </sidebar-container>
  <content-container class="flex flex-col items-stretch w-full">
    <div class="flex flex-col items-stretch h-28 z-10" sticky>
      <section-head>
        <ng-container left>
          <h5 class="text-zen font-medium text-3xl">{{'txtAccountOverview'| translate:language:ModuleNames.Common }}
            {{'- ' +
            extractNameLanguage(selected?.entityName) }}</h5>
        </ng-container>
        <ng-container right>
          <button zenButton styles="exp height-12" class="uppercase" (click)="requestMoreUnits(null)">{{
            "btnRequestUnits"| translate:language:ModuleNames.Common }}</button>
        </ng-container>
      </section-head>
    </div>
    <div class="flex flex-col mt-10 px-5" *ngIf="selected?.key">
      <app-table [options]="productTableOptions" [language]="language" [module]="ModuleNames.Common">
        <ng-template let-product let-column="column">
          <div *ngIf="column == 'product'" class="flex flex-row items-center gap-5 py-5">
            <img class="h-15" [src]="product.image" alt="">
            <div>
              <h6 class="text-xxs text-zen uppercase font-medium whitespace-nowrap text-start">ZENITHR</h6>
              <h5 class="text-lg text-zen font-medium -mb-1">{{product.name|
                translate:language:ModuleNames.Common }}</h5>
            </div>
          </div>

          <h5 *ngIf="column == 'currentBalance'" class="text-lg text-zen font-medium py-5">
            {{selected.balanceDistribution[product.currentBalance] | number:'1.0':'en-US'}}</h5>

          <h5 *ngIf="column == 'usedBalance'" class="text-lg text-zen font-medium py-5">
            {{selected.balanceDistribution[product.usedBalance] | number:'1.0':'en-US'}}</h5>

          <div *ngIf="column == 'assign'" class="flex flex-row justify-start items-center gap-5 py-5">
            <z-input [number]="true" [(ngModel)]="unitsToAssign[product.key]" placeholder="0">
            </z-input>
            <button zenButton styles="secondary height-10"
              (click)="addUnits(selected, product.key, unitsToAssign[product.key])">{{'txtAssign'|
              translate:language:ModuleNames.Common }}</button>
          </div>

          <button *ngIf="column == 'history'" zenButton styles="secondary height-10" class="whitespace-nowrap"
            (click)="purchaseHistory('Entity', product)">{{'txtAllocationHistory'|
            translate:language:ModuleNames.Common }}</button>
        </ng-template>
      </app-table>
    </div>
  </content-container>
</zen-main-container>


<z-drawer #historyDrawer [(open)]="historyModal" [dir]="(language | language) ? 'rtl' : 'ltr'" *ngIf="historyModal">
  <ng-container header>
    <!-- Product logo, then an eyebrow line naming the history and, for a company's
         allocations, whose it is — over the product name. Keeping the organization here
         rather than in the body avoids a second text-2xl heading competing with this one. -->
    <div class="flex flex-row items-center gap-4 min-w-0">
      <img class="h-10 w-10 object-contain shrink-0" [src]="selectedProduct.image" alt="">
      <div class="flex flex-col min-w-0">
        <h5 class="text-sm text-zen-primaryLight truncate">
          {{ (historyType == 'Entity' ? 'txtAllocationHistory' : 'txtPurchaseHistory') |
            translate:language:ModuleNames.Common }}<ng-container *ngIf="historyType == 'Entity'"> <span
              class="px-1">&middot;</span> <span class="text-zen font-medium">{{
              extractNameLanguage(selected.entityName) }}</span></ng-container>
        </h5>
        <h4 class="text-2xl font-bold text-zen truncate">{{selectedProduct.name|
          translate:language:ModuleNames.Common }}</h4>
      </div>
    </div>
    <div class="flex flex-row gap-5 items-center">
      <!-- close(), not historyModal = false: the outer *ngIf would otherwise tear the
           drawer out before its leave animation runs, so the button snapped shut while
           the backdrop faded out. -->
      <button zenButton styles="secondary height-12" (click)="historyDrawer.close()">{{'txt_close'|
        translate:language:ModuleNames.Common }}</button>

    </div>
  </ng-container>

  <ng-container body>
    <!-- px-10 to line the body up with z-drawer's own header padding. Fixed width because
         the drawer is w-auto: without it the panel is as wide as whatever the history
         happens to contain, and changes size between products. -->
    <div class="flex flex-col gap-6 px-10 pt-6 pb-8 w-[42rem] max-w-full">
      <t-table [options]="options" *ngIf="options?.data">
        <ng-template #cellTempate let-element let-column='column' let-index="index">
          <div *ngIf="column.field == 'first'" class="flex flex-col items-start py-5">
            <h5 class="text-base text-zen font-medium">{{ element.actualUnits}}</h5>
          </div>
          <div *ngIf="column.field == 'second'" class="flex flex-col items-start py-5">
            <h5 class="text-base text-zen font-medium">{{ getReadableDate(element.createdDate)}}</h5>
          </div>
          <div *ngIf="column.field == 'third'" class="flex flex-col items-start py-5">
            <h5 class="text-base text-zen font-medium">{{ getReadableDate(element.expiryUnitDate)}}</h5>
          </div>
        </ng-template>
      </t-table>
    </div>
  </ng-container>

</z-drawer>


<ng-template #unitOverview let-product>
  <div class="flex flex-row justify-between items-center px-8">
    <div class="flex flex-col  gap-1.5">
      <h2 class="text-sm text-zen font-normal">{{product.name | translate:language:ModuleNames.Common }} </h2>
      <h2 class="text-zen"> <span class="text-lg font-semibold">{{ balances[product.tenantBalance] | number:'1.0':'en-US' }}</span>
        <span class="text-xs font-normal px-1">{{'txt_units'| translate:language:ModuleNames.Common }}</span>
      </h2>
    </div>
    <button zenButton styles="secondary icon-8" [matTooltip]="'txtPurchaseHistory'|translate:language:ModuleNames.Common"
      (click)="purchaseHistory('Tenant', product)"><i class="fal fa-history"></i></button>
  </div>
</ng-template>
